export class ToolFilterOption {
  key: string;
  value: string;
  title: string;
  count: number;
  selected: boolean;
}
